import React from 'react';
import { EmployeeLink } from '../links/index.jsx';
import { UserIcon } from '../icons/UserIcon.jsx';

const EmployeeLabel = ({ employeeId, employeeName, archived }) => {
  return (
    <EmployeeLink employeeId={employeeId}>
      <a className="flex flex-1 strong text-active">
        <div
          className="m-r-10"
          style={{ filter: archived ? 'grayscale(60%)' : 'none' }}
        >
          <UserIcon />
        </div>

        <div className={`${archived ? 'text-muted' : ''}`}>{employeeName}</div>
      </a>
    </EmployeeLink>
  );
};

export default EmployeeLabel;
